import Breadcrumb from "../../Component/Breadcrumb";
function SchoolFee() {
  return (
    <>
      <Breadcrumb>Prospects / Fee Structure </Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Fee Structure </h1>
            </div>

            <div className="col-lg-12">
              <h3>DETAILS OF THE FEE STRUCTURE</h3>
              <p>For the fee payable for this academic year please refer the fee sheet attached. The details of fees for the previous year and current year are attached herewith. All payments must be made before the date specified in the fee book and fee will be must deposited in Indian Overseas Bank (No cash will be accepted). Parents will kindly keep the receipts issued to them safely and shall produce them in proof of payment, if needed.<br />
                No child will be permitted to begin a new term unless all arrears due on his/her account have been cleared in full before the commencement of the new term. A student not paying fees on time will have to pay a fine of Rs. 50/- per month in addition to the arrears.<br />
                Application processing fee Rs. 300/- is payable at the time of registration. (For new students only)<br /><br />
                * Board charges extra for classes IX-XII will be payable.<br />
                * The Exam Fee is remitted in the first & Third installment and composite fee is remitted quarterly, in four installments</p>
              <br />
              <iframe
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/pdf/FeeStructure.pdf"
                width="100%"
                height="800px"
                style={{ border: "none" }}
                title="Bus Routes PDF"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default SchoolFee;
